import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'modals',
    children: [
      {
        path: 'read-list',
        loadChildren: './read-list/read-list.module#ReadListModalModule'
      },
      {
        path: 'select-targets',
        loadChildren:
          './select-letter-targets/select-letter-targets.module#SelectLetterTargetsModule'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ModalsRoutingModule {}
